"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NativeDragSource = /** @class */ (function () {
    function NativeDragSource(config) {
        this.config = config;
        this.item = {};
        this.initializeExposedProperties();
    }
    NativeDragSource.prototype.initializeExposedProperties = function () {
        var _this = this;
        Object.keys(this.config.exposeProperties).forEach(function (property) {
            Object.defineProperty(_this.item, property, {
                configurable: true,
                enumerable: true,
                get: function () {
                    // eslint-disable-next-line no-console
                    console.warn("Browser doesn't allow reading \"" + property + "\" until the drop event.");
                    return null;
                },
            });
        });
    };
    NativeDragSource.prototype.loadDataTransfer = function (dataTransfer) {
        var _this = this;
        if (dataTransfer) {
            var newProperties_1 = {};
            Object.keys(this.config.exposeProperties).forEach(function (property) {
                newProperties_1[property] = {
                    value: _this.config.exposeProperties[property](dataTransfer, _this.config.matchesTypes),
                    configurable: true,
                    enumerable: true,
                };
            });
            Object.defineProperties(this.item, newProperties_1);
        }
    };
    NativeDragSource.prototype.canDrag = function () {
        return true;
    };
    NativeDragSource.prototype.beginDrag = function () {
        return this.item;
    };
    NativeDragSource.prototype.isDragging = function (monitor, handle) {
        return handle === monitor.getSourceId();
    };
    NativeDragSource.prototype.endDrag = function () {
        // empty
    };
    return NativeDragSource;
}());
exports.NativeDragSource = NativeDragSource;
